import { call, put, select, debounce } from 'redux-saga/effects'
import { resolveUserActions, ResolveUserActionTypes } from '@gtresolve/state/user/actions'
import { submitAbandonedCart } from '@gtresolve/services'
import { fatalErrorActions } from '@common/state/fatal-error/actions'
import { COOKIE_NAMES, LANGUAGE_CODES } from '@common/constants'
import Cookies from 'js-cookie'
import { getCheckoutState, getUserState } from '@gtresolve/state/selectors'
import { ResolveCheckoutState } from '@gtresolve/state/checkout/state'
import { ResolveAbandonedCartPayload, ResolveUserState } from '@gtresolve/state/user/state'
import { LocationState } from '@common/state/location/state'
import { getLocationState } from '@common/state/selectors'
import { sanitizePayload } from '@common/utils/aws-utils'

export function* abandonedCartSaga(action: ReturnType<typeof resolveUserActions.submitAbandonedCart>) {
    const { isTrial, email, success, form } = action.payload.abandonedCartData
    const { locationInfo }: LocationState = yield select(getLocationState)
    const urlSplitForLanguage = window.location.pathname.split('/')[1]
    const isValidLanguageCode = Object.values(LANGUAGE_CODES).includes(urlSplitForLanguage)
    const siteLanguage = isValidLanguageCode ? urlSplitForLanguage : LANGUAGE_CODES.English
    const data: ResolveAbandonedCartPayload = {
        success: success.toString(),
        email,
        mkto_trk: Cookies.get(COOKIE_NAMES.MARKETO_TRK) || '',
        country: locationInfo?.country,
        language: siteLanguage,
        program: null,
        firstName: null,
        lastName: null,
        plan: null,
    }

    if (isTrial && !success) {
        data.firstName = form?.firstName
        data.lastName = form?.lastName
    }

    if (!isTrial && !success) {
        const { existingUserInformation }: ResolveUserState = yield select(getUserState)
        const { selectedPlanSku }: ResolveCheckoutState = yield select(getCheckoutState)
        data.plan = selectedPlanSku
        data.firstName = form?.firstName || existingUserInformation?.Name?.GivenName
        data.lastName = form?.lastName || existingUserInformation?.Name?.FamilyName
        data.program = 'GTRe_Global_EN_TRG_Lead_Promo_Abandoned Cart'
    }

    try {
        // yield delay(1000)
        yield call(submitAbandonedCart, sanitizePayload(data))
    } catch (e) {
        yield put(fatalErrorActions.setFatalError(true, { trackErrorMessage: 'failed to post abandoned email api' }))
    }
}

function* initializeAbandonedCartSaga() {
    yield debounce(1000, ResolveUserActionTypes.SUBMIT_ABANDONED_CART, abandonedCartSaga)
}

export default initializeAbandonedCartSaga
